import { theme } from '@theme';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import ModalTitle from '../../../../../components/shared/modals/ModalTitle';
import SelectMake from '../../../../admin/settings/shared/selectMake';

type BulkInventoryContainerProps = {
  isOpen: boolean;
  title: string;
  showCloseIcon?: boolean;
  overlayClassName?: string;
  contentClassName?: string;
  handleCancelClick: Dispatch<SetStateAction<boolean>>;
  dealerSelect: any;
  availableDealerList: Array<string>;
};

const BulkInventoryContainer: FC<BulkInventoryContainerProps> = (props) => {
  const [dealerList, SetDealerList] = useState([]);
  const msgList = [
    'You’ve selected multiple makes and only one make can be replaced at a time.',
    'Please select a specific make and repeat this action for each set of makes you would like to replace.',
  ];

  useEffect(() => {
    const dealerInfos = JSON.parse(localStorage.getItem('dealerInfos'));

    const sortedList = dealerInfos.sort((a, b) => a.brandName.localeCompare(b.brandName));
    const offBrandIndex = dealerInfos.findIndex((v) => v.brandName.startsWith('Off'));

    // If such a record is found, move it to the end of the array
    if (offBrandIndex !== -1) {
      const offBrandRecord = sortedList.splice(offBrandIndex, 1)[0];
      sortedList.push(offBrandRecord);
    }

    const dataList = [];
    sortedList.map((e) => {
      const data = { brandName: e.brandName, conquestState: e.conquestState, dealerId: e.dealerId };
      if (props.availableDealerList.includes(e.dealerId)) {
        dataList.push(data);
      }
    });
    SetDealerList(dataList);
  }, []);

  const closeConfirmationModal = () => {
    props.handleCancelClick(false);
  };

  const selectmake = (selected) => {
    props.dealerSelect(selected);
  };

  return (
    <Modal
      data-testid='help-modal'
      isOpen={props.isOpen}
      onRequestClose={closeConfirmationModal}
      overlayClassName={props.overlayClassName ?? undefined}
      className={props.contentClassName ?? undefined}
      style={modalStyles}
      contentLabel='Help  Modal'
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
    >
      <ModalTitle
        data-testid='modal-title'
        bgColor={theme.palette.text.purple}
        title={props.title}
        size={theme.typography.h4}
        color={theme.palette.white}
        fontWeight={theme.typography.fontWeights.semibold}
        iconColor={theme.palette.white}
        height='56px'
        showCloseIcon={props?.showCloseIcon ? props.showCloseIcon : false}
        handleIconClick={closeConfirmationModal}
        titleClassName='modal-title-text'
      />
      <ModalBody data-testid='modal-body'>
        <SelectMake
          data={dealerList}
          headerName={''}
          onSelectMake={selectmake}
          warningMsgList={msgList}
        />
      </ModalBody>
    </Modal>
  );
};

export default BulkInventoryContainer;

const ModalBody = styled.div`
  padding: 40px 100px;
  width: auto;
  min-height: 450px;
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minHeight: '450px',
    maxHeight: '640px',
    zIndex: 96,
    padding: '0',
    borderRadius: '5px',
    minWidth: '1000px',
  },
};
